<template>
  <td v-if="actions.length > 0" class="table-actions">
    <template v-for="(action, index) in actions">
      <check-permission
        v-if="checkModule(action) && checkAction(action, object)"
        :key="action.permissions + '_' + action.event + '_' + index"
        :entity-id="action.entityId ? action.entityId : object[idKey]"
        :entity-type="action.entityType ? action.entityType : entityType"
        :permissions="action.permissions ? action.permissions : getPermissions(action.permissionTypes)"
      >
        <tooltip :text="action.tooltipText || object.tooltipText">
          <button
            class="btn btn-icon btn-light mr-2"
            :aria-label="action.tooltipText"
            :class="action.class"
            :style="{ color: actionColor(action) }"
            @click.prevent="$emit(action.event, prepareData(action, object))"
          >
            <i aria-hidden="true" :class="action.icon" />
            {{ action.name }}
          </button>
        </tooltip>
      </check-permission>
    </template>
  </td>
</template>

<script>
import Tooltip from '@/components/tooltip/Tooltip';
import { actionsMixin } from '@/mixins/actions';

// @vuese
// Akcje tabeli
// @group Table
export default {
  name: 'TActions',
  components: { Tooltip },
  mixins: [actionsMixin],
  props: {
    // Klucz identyfikatora
    idKey: { type: String, required: false, default: 'id' }
  },
  methods: {
    // @vuese
    // Sprawdza, czy akcja powinna być widoczna
    checkAction(action, object) {
      if (action && action.check) {
        if (typeof action.check === 'string') {
          action.check = new Function('object', 'action', action.check);
        }
        return action.check(object, action);
      }
      return true;
    },

    // @vuese
    // Przygotowuje dane do emitu
    prepareData(action, object) {
      return action.id ? { object: { ...object, id: object.documentId }, action } : object;
    }
  }
};
</script>
